import { Organization } from 'interfaces';
import { http, HttpResponse } from 'msw';
import { buildOrganization } from '../../factories';
import { canonicalOrganizations } from '../../factories/seeds/entities';
import { mockSites } from './siteMock';

const organizationOrder = [
  '229dcbb6-a0e7-4287-a373-385d251b6c5e',
  '35bc3fb7-adb0-4ec8-84c0-22d7ed0b1ea3',
  '8f2decd9-6e32-4746-864b-9c9ba5367775',
  'ff88e4f8-3b0b-49c7-aa8e-4d5095e1db3b',
  '53ff0a7e-ab2b-4cc5-9cf8-ddf5eba85997',
];

export const mockOrganizations: Organization[] = organizationOrder
  .map((organizationID) =>
    canonicalOrganizations.find(
      (organization) => organization.id === organizationID
    )
  )
  .filter(
    (organization): organization is (typeof canonicalOrganizations)[number] =>
      Boolean(organization)
  )
  .map(
    (organization) =>
      buildOrganization<Organization>({
        ...organization,
        sites: mockSites.filter(
          (site) => site.organizationID === organization.id
        ),
      }) as Organization
  );

export const mockOrganizationHandlers = [
  http.get('*/resource/organization/all', () => {
    return HttpResponse.json(mockOrganizations);
  }),
  // useListOrganization returns a single organization for non admins
  http.get('*/resource/organization', ({ request }) => {
    const url = new URL(request.url).searchParams;
    const id = url.get('id');
    return HttpResponse.json(mockOrganizations.find((org) => org.id === id));
  }),
];
